module.exports = __webpack_public_path__ + "img/webmoney.fc9db66c.jpg";